var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';
import { getRebornUrl } from '@/shared/utils/helpers';
/**
 * Tempo máximo à espera do EXPORT_MODAL_READY do atlas-reborn — o aviso de que
 * o modal novo realmente vai aparecer. Estourou, tratamos como indisponível e
 * caímos no modal antigo, senão o usuário fica olhando um diálogo em branco
 * (rota /export fora do ar, bundle não deployado, gate pendurado numa consulta
 * lenta, ou EXPORT_INIT descartado pelo React).
 *
 * Repare que NÃO é o IFRAME_READY que desarma este relógio: aquele só diz que o
 * bundle carregou, e chega antes de qualquer decisão sobre a feature flag.
 */
const READY_TIMEOUT_MS = 8000;
let InfosetExportIframeModal = class InfosetExportIframeModal extends Vue {
    constructor() {
        super(...arguments);
        this.retryTimers = [];
        this.readyTimer = null;
        this.deniedEmitted = false;
    }
    get iframeSrc() {
        return `${getRebornUrl()}/export`;
    }
    onLoad() {
        this.clearRetryTimers();
        this.sendInit();
        this.retryTimers.push(setTimeout(() => this.sendInit(), 500));
        this.retryTimers.push(setTimeout(() => this.sendInit(), 2000));
    }
    sendInit() {
        const iframe = this.$refs.iframe;
        if (!iframe || !iframe.contentWindow)
            return;
        // @ts-ignore TS2349: $auth injetado pelo vue-auth
        const user = this.$auth.user() || {};
        iframe.contentWindow.postMessage({
            type: 'EXPORT_INIT',
            infoSetId: this.infosetId,
            infoSetName: this.infosetName,
            accountId: user.account_id || '',
            userId: user.id || '',
            token: localStorage.getItem('auth_token_default') || '',
            // As feature flags da conta viajam no handshake porque o shell já as
            // tem (GET user/me do Rails) e são a mesma fonte de verdade que o
            // reborn leria (accounts.feature_flags). Poupa o React de uma consulta
            // e mantém o gate funcionando mesmo com o /user/me do reborn fora.
            features: Array.isArray(user.features) ? user.features : [],
        }, '*');
    }
    handleMessage(event) {
        if (!event.data)
            return;
        const tipo = event.data.type;
        if (tipo === 'IFRAME_READY') {
            this.clearRetryTimers();
            this.sendInit();
            return;
        }
        if (tipo === 'EXPORT_MODAL_READY') {
            // O modal novo montou: a partir daqui o iframe se sustenta sozinho.
            this.clearRetryTimers();
            this.clearReadyTimer();
            return;
        }
        if (tipo === 'EXPORT_MODAL_DENIED') {
            // O reborn avisa que esta conta não tem a flag do modal novo (ou que não
            // conseguiu descobrir). Quem decide o que fazer é o pai — aqui só
            // reportamos.
            this.emitDenied(event.data.reason || 'feature_disabled');
            return;
        }
        if (tipo === 'CLOSE_EXPORT_MODAL') {
            this.close();
        }
    }
    /** Emite `denied` uma única vez (o watchdog e o reborn podem competir). */
    emitDenied(reason) {
        if (this.deniedEmitted)
            return;
        this.deniedEmitted = true;
        this.clearRetryTimers();
        this.clearReadyTimer();
        this.$emit('denied', reason);
    }
    close() {
        this.$emit('close');
    }
    clearRetryTimers() {
        this.retryTimers.forEach(t => clearTimeout(t));
        this.retryTimers = [];
    }
    clearReadyTimer() {
        if (this.readyTimer)
            clearTimeout(this.readyTimer);
        this.readyTimer = null;
    }
    mounted() {
        window.addEventListener('message', this.handleMessage);
        // Conta a partir do mount, não do @load: se o bundle não subir, o @load
        // pode nunca disparar de forma útil.
        this.readyTimer = setTimeout(() => this.emitDenied('iframe_unavailable'), READY_TIMEOUT_MS);
    }
    beforeDestroy() {
        this.clearRetryTimers();
        this.clearReadyTimer();
        window.removeEventListener('message', this.handleMessage);
    }
};
__decorate([
    PropSync('open', { default: false })
], InfosetExportIframeModal.prototype, "showModal", void 0);
__decorate([
    Prop({ default: '' })
], InfosetExportIframeModal.prototype, "infosetId", void 0);
__decorate([
    Prop({ default: '' })
], InfosetExportIframeModal.prototype, "infosetName", void 0);
InfosetExportIframeModal = __decorate([
    Component({ name: 'InfosetExportIframeModal' })
], InfosetExportIframeModal);
export default InfosetExportIframeModal;
